window.POV = window.POV || {};

(function (namespace) {
  'use strict';

  var events = {
    init: 'cart:init',
    load: {
      start: 'cart:load:start',
      // error: 'cart:load:error',
      success: 'cart:load:success',
    },
    get: {
      start: 'cart:get:start',
      error: 'cart:get:error',
      success: 'cart:get:success',
    },
    add: {
      start: 'cart:add:start',
      error: 'cart:add:error',
      success: 'cart:add:success',
    },
    update: {
      start: 'cart:update:start',
      error: 'cart:update:error',
      success: 'cart:update:success',
    },
  };

  var selectors = {
    atcButton: '#AddToCart',
    mainProductForm: '#MainProductForm',
    errorModal: '[data-cart-error-modal]',
    errorContent: '[data-cart-error-content]',
    body: 'body',
    cartCounter: '.cart__count',
    cartContent: '[data-cart-content]',
    cartContainer: '#CartContainer',
    formBonusProperty: '[data-cart-form-bonus-property]',
    add: '[data-cart-form-add]',
    change: '[data-cart-form-change]',
    cartQtyChange: '[data-cart-quantity-change]',
    isBonusLine: '[data-is-bonus]',
    hasBonusLine: '[data-has-bonus]',
    bonusItemInput: '[data-cart-form-bonus-id]',
  };

  var loaderClasses = {
    cartLoading: 'cart-loading',
  };

  /**
   * loadSequence fetches /sections=cart HTML and updates the DOM
   */
  var loadSequence = compose(
    // partial(maybeEmitError, events.load.error),
    partial(maybeEmitSuccess, events.load.success),
    partial(removeClass, selectors.body, loaderClasses.cartLoading),
    updateCartDOM,
    getCartMarkup,
    partial(addClass, selectors.body, loaderClasses.cartLoading),
    partial(emitStart, events.load.start)
  );

  /**
   * getSequence fetches /cart.js JSON
   */
  var getSequence = compose(
    partial(maybeEmitError, events.get.error),
    partial(maybeEmitSuccess, events.get.success),
    getCart,
    partial(emitStart, events.get.start)
  );

  var addSequence = compose(
    partial(maybeEmitError, events.add.error),
    partial(maybeEmitSuccess, events.add.success),
    partial(removeClass, selectors.body, loaderClasses.cartLoading),
    addToCart,
    partial(addClass, selectors.body, loaderClasses.cartLoading),
    partial(emitStart, events.add.start),
    normalizeData,
    updateBonusItemsTimestamp
  );

  var updateSequence = compose(
    partial(maybeEmitError, events.update.error),
    partial(maybeEmitSuccess, events.update.success),
    partial(removeClass, selectors.body, loaderClasses.cartLoading),
    updateCartDOM,
    getCartMarkup,
    updateCart,
    partial(addClass, selectors.body, loaderClasses.cartLoading),
    partial(emitStart, events.update.start),
    collateUpdateData
  );

  // Public API
  namespace.Cart = {
    get: getSequence,
    add: addSequence,
    load: loadSequence,
    update: updateSequence,
    selectors: selectors,
    events: events,
  };

  // Emit API ready event
  POV.emit(events.init);

  
  /******* Event Handlers *******/

  window.addEventListener('submit', function (e) {
    var submittedForm = e.target;
    if (submittedForm.matches(selectors.add)) {
      e.preventDefault();
      var formData = new FormData(submittedForm);
      addSequence(formData);
    }
  });

  window.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches(selectors.change)) {
      updateSequence(input);
    }
  });

  window.addEventListener('click', function (e) {
    var target = e.target;
    var triggerBtn = target.closest(selectors.cartQtyChange);

    if (!triggerBtn) return;

    e.preventDefault();

    var input = triggerBtn.parentElement.querySelector(selectors.change);
    var newQty = Number(triggerBtn.dataset.qty);
    input.value = newQty;
    var changeEvent = new Event('change', { bubbles: true });
    input.dispatchEvent(changeEvent);
  });

  window.addEventListener(events.add.success, updateCartCounter);
  window.addEventListener(events.update.success, updateCartCounter);
  async function updateCartCounter() {
    var cart = await getSequence();
    var counter = document.querySelector(selectors.cartCounter);
    counter.innerHTML = cart.item_count;
  }

  window.addEventListener(events.add.success, loadSequence);

  window.addEventListener(events.add.error, displayError);
  window.addEventListener(events.get.error, displayError);
  window.addEventListener(events.update.error, displayError);
  // window.addEventListener(events.load.error, displayError);
  function displayError(e) {
    var errorModal = document.querySelector(selectors.errorModal);
    var errorContent = document.querySelector(selectors.errorContent);
    errorContent.textContent = e.detail;
    errorModal.removeAttribute('hidden');
  }


  /***** Update Logic *****/

  async function updateCart(fetchParams) {
    return await requestShopifyCart('/cart/update.js', fetchParams);
  }

  async function collateUpdateData(inputNode) {
    var newQuantity = Number(inputNode.value);
    var lineKey = inputNode.dataset.key;
    var changesObj = { [lineKey]: newQuantity };

    var bonusId = inputNode.dataset.hasBonus;
    if (bonusId) {
      // Select the bonus line input nodes with a matching bonusId. Selector [data-is-bonus] becomes [data-is-bonus="123456"]
      var bonusInputNodes = nodeList(selectors.isBonusLine.replace(']', `="${bonusId}"]`));
      bonusInputNodes.forEach(function (inputNode) {
        var bonusLineKey = inputNode.dataset.key;
        changesObj[bonusLineKey] = newQuantity;
      });
    }

    return {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({
        updates: changesObj
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    };
  }


  /***** ATC Logic *****/

  async function addToCart(fetchParams) {
    return await requestShopifyCart('/cart/add.js', fetchParams);
  }

  // On add to cart, the bonus items proprieties need to have a fresh identifier/timestamp
  function updateBonusItemsTimestamp(data) {
    var identifier = String(Date.now());
    nodeList(selectors.formBonusProperty).forEach(function (node) {
      node.value = identifier;
    });

    return data;
  }

  function normalizeData(data) {
    var fetchParams = {
      method: 'POST',
      credentials: 'include'
    };

    if (data instanceof FormData) {
      fetchParams.body = data;
    } else {
      fetchParams.body = JSON.stringify(data);
      fetchParams.headers = { 'Content-Type': 'application/json' };
    }

    return fetchParams;
  }


  /***** Get Logic *****/

  async function getCart() {
    return await requestShopifyCart('/cart.js', { method: 'GET', credentials: 'include'  });
  }


  /***** Load Logic *****/

  async function getCartMarkup(response) {
    if (response && response.isError) return response;
    return await requestShopifyCart('/?sections=cart', { method: 'GET', credentials: 'include' });
  }

  function updateCartDOM(response) {

    if (response.isError) return response;

    var frg = document.createElement('div');
    frg.innerHTML = response.cart;
    var contentHTML = frg.querySelector(selectors.cartContent).innerHTML;
    var cartContainer = document.querySelector(selectors.cartContainer);
    cartContainer.innerHTML = contentHTML;

    return response;
  }


  /******* Global Logic *******/

  async function requestShopifyCart(endpoint, fetchParams) {
    try {
      var response = await fetch(endpoint, fetchParams);
      var responseJson = await response.json();
      if (!response.ok) throw { displayMessage: `${response.status} ${responseJson.message}: ${responseJson.description}` };

      return responseJson;
    } catch (error) {

      return {
        isError: true,
        errorMessage: error.displayMessage || 'An unknown error ocurred. Please refresh your browser window and try again.'
      }
    }
  }

  function emitStart(eventType, fetchParams) {
    POV.emit(eventType);
    return fetchParams;
  }

  function maybeEmitSuccess(eventType, response) {
    if (!response.isError) POV.emit(eventType);
    return response;
  }

  function maybeEmitError(eventType, response) {
    if (response.isError) POV.emit(eventType, response.errorMessage);
    return response;
  }

  function removeClass(selector, className, response) {
    var element = document.querySelector(selector);
    if (element) element.classList.remove(className);
    return response;
  }

  function addClass(selector, className, fetchParams) {
    var element = document.querySelector(selector);
    if (element) element.classList.add(className);
    return fetchParams;
  }


  /******* Utils *******/

  function compose2(f, g) {
    return async function () {
      return f(await g.apply(void 0, arguments));
    };
  }

  function compose() {
    for (
      var _len = arguments.length, fns = new Array(_len), _key = 0;
      _key < _len;
      _key++
    ) {
      fns[_key] = arguments[_key];
    }
    return fns.reduce(compose2);
  }

})(POV);


